import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../common/Pagination/Pagination';
import Loader from './Loader';
import siteQueries from '../../queries/siteQueries';
import MainHeader from './MainHeader';
import Footer from './Footer';
import { BASE_URL } from '../../apis/api';
import BannerBg from '../../images/cover/inner-banner-bg.jpg';
import { useScrollToTop } from '../../hooks/ScrollTop';

export default function NewsSite() {
    const [news, setNews] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [totalPage, setTotalPage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const newsData = siteQueries.useNewsMutation((response) => {
        setNews(response?.data?.items);
        setTotalCount(response?.data?.totalItems);
        setTotalPage(response?.data?.totalPages);
        setIsLoading(false);
    });

    useEffect(() => {
        newsData.mutateAsync({ page: currentPage, size: pageSize });
    }, [currentPage, pageSize]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleReadMore = (item) => {
        navigate(`/newsviewsite/${item.id}/${item.shortdescription}`);
    };

    const decodeHtml = (html) => {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    };

    useEffect(() => {
        document.title = `News | International Literature Festival of Kerala 2025`;
        return () => {
            document.title = 'ILFK 2025 | International Lit Fest | Literature Festival | Literary Festival 2025';
        };
    }, []);
useScrollToTop()
    return (
        <div className="min-h-screen bg-slate-50 from-gray-100 to-gray-200 newsContainer">
            <MainHeader />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {/* Modern Banner */}
                    <div className="min-h-[190px] flex justify-center items-center text-bla py-4 relative overflow-hidden"
                        style={{
                            backgroundImage: `url(${BannerBg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <div className="relative z-5 text-center px-4">
                            <h1 className="text-4xl sm:text-2xl font-bold drop-shadow-md">
                                <span className="text-yellow-400 text-[36px]">News</span>
                            </h1>
                            <p className="text-white text-[15px] sm:text-[18px] mt-2 font-semibold opacity-90">
                                Stay updated with the latest from International Literature Festival of Kerala 2025
                            </p>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-5 newsCards">
                        {/* Stats */}
                        <div className="text-left border-b p-4 mb-6">
                            <p className="text-gray-600 text-[16] text-[#000]">
                                Showing <span className="font-semibold">{news.length}</span> of{' '}
                                <span className="font-semibold">{totalCount}</span> news articles
                            </p>
                        </div>

                        {/* Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {news.map((item, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleReadMore(item)}
                                    className="cursor-pointer bg-white rounded-xl overflow-hidden shadow-lg transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl flex flex-col h-[450px]"
                                >
                                    <img
                                        src={`${BASE_URL}/${item.image}`}
                                        alt={item.shortdescription}
                                        className="w-full h-52 object-cover transition-transform duration-300 hover:scale-105"
                                        loading="lazy"
                                    />
                                    <div className="p-4 flex flex-col flex-grow">
                                        <h3 className="text-gray-800 font-semibold text-[13px] mb-2 line-clamp-2 leading-normal">
                                            {item.shortdescription}
                                        </h3>
                                        <div
                                            className="text-gray-600 text-sm leading-relaxed line-clamp-4 flex-grow"
                                            dangerouslySetInnerHTML={{
                                                __html: decodeHtml(item.maindescription)
                                            }}
                                        />
                                        <div className="mt-4 readFullArticleBtn">
                                            <button 
                                            onClick={() => handleReadMore(item)}
                                            className="bg-[#eac94e] text-black text-sm font-medium px-4 py-2 rounded-full shadow hover:shadow-lg transition-all">
                                                Read Full Article →
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Pagination */}
                        <div className="flex justify-center mt-10">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </>
            )}
            <Footer />
        </div>
    );
}
